export default __webpack_public_path__ + "static/media/tbExcelUpload.f6c149ac.svg";